import React from 'react'
import styled from "@emotion/styled";
import { Box } from '@mui/material';
import BtnPrimary from '../component/PrimaryButton';

import { displayFont } from "../theme";
const Page = styled(Box)({
    height:"100vh",
    padding: "2rem 1.25rem", 
    display:"flex",
    flexDirection:"column",  
    alignItems:"center",
    justifyContent:"center"
});

const TextBox = styled(Box)({
    fontFamily: displayFont, fontWeight: 600, fontSize: "1.25rem",
    color: "#2A1D22",
});

const ErrorPage = () => {
  return (
    <Page>
        <TextBox>The page you are looking for does not exists!</TextBox>
        <BtnPrimary sx={{marginTop: "1rem"}} to="/app">Back to dashboard</BtnPrimary>
    </Page>
  )
}

export default ErrorPage